import { appInsights } from './AppInsights.service';

interface ImageSizes {
  url?: string;
}

interface Post {
  excerpt?: string;
  title?: string;
  thumbnail_images?: {
    full?: ImageSizes;
    thumbnail?: ImageSizes;
    medium?: ImageSizes;
    medium_large?: ImageSizes;
    large?: ImageSizes;
  };
  url?: string;
}

interface HealthNewsFeedResponse {
  status?: string;
  count?: number;
  posts?: Post[];
}

export async function fetchHealthNewsFeed(
  apiSlug: string,
  numberOfResults: number
): Promise<Post[]> {
  if (apiSlug == null || numberOfResults < 1) return [];

  const healthNewsFeedUrl = process.env.HEALTH_NEWS_FEED_URL || '';
  const url = `${healthNewsFeedUrl}?slug=${apiSlug}&count=${numberOfResults}`;
  const urlObj = new URL(url);
  const startTime = Date.now();

  let response: Response | undefined;
  let err: unknown = null;

  try {
    response = await fetch(url);

    if (response.ok) {
      const healthNewsFeed: HealthNewsFeedResponse = await response.json();
      return healthNewsFeed?.posts ?? [];
    } else {
      console.error('Response not ok:', response.statusText);
      return []; // Return an empty object in case of an error response
    }
  } catch (error) {
    console.error('There has been a problem with your fetch operation:', error);
    err = error;
    return []; // Return an empty object in case of fetch error
  } finally {
    const durationMs = Date.now() - startTime;
    const statusCode = response?.status ?? 0;

    // Log the dependency call using Application Insights
    appInsights.trackDependencyData({
      target: urlObj.host,
      name: `GET ${urlObj.pathname}`,
      data: url,
      duration: durationMs,
      responseCode: statusCode,
      // This may need some work to support GraphQL (but we don't have access to the response object)
      success: !err && statusCode >= 200 && statusCode < 400,
      startTime: new Date(startTime),
      id: 'HTTP',
    });
  }
}
